import * as fromProducer from "./producer/producer.effects";
import * as fromProduct from "./product/product.effects";

export const effects = [
  fromProducer.ProducerEffects,
  fromProduct.ProductEffects,
];
